import * as api from '../../../../../lib/api/v1';

export class EmpionRecommendedActionsService {
  // -- PATCH --
  async toggleActionItems(id: string) {
    try {
      const response = await api.toggleActionItems(id);
      if (response.ok) {
        return {
          ok: true,
          data: undefined,
          error: undefined,
        };
      }
      return {
        ok: false,
        data: undefined,
        error: undefined,
      };
    } catch (error: any) {
      console.error('Error toggling action items', error);
      return {
        ok: false,
        data: undefined,
        error: {
          error_code: 'CLI_0000',
          error_message: 'Web client error',
          extra_details: error.message,
        },
      };
    }
  }
}
